import React from 'react';

export const NxButton = React.forwardRef(function NxButton(
  { variant = 'primary', as: Tag = 'button', className = '', children, ...rest },
  ref
) {
  const cls = `nx-btn nx-btn--${variant} ${className}`.trim();
  return (
    <Tag ref={ref} className={cls} {...rest}>
      {children}
    </Tag>
  );
});
